import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useAuthState } from "../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { RegExOnlyText } from "../../../../Helper/regEx/RegExOnlyText";
import { ProjectNameDDL } from "../../../../Components/CommonDDL/ProjectNameDDL";
import { StateNameDDL } from "../../../../Components/CommonDDL/StateNameDDL";
import { RegionalOfficeNameDDL } from "../../../../Components/CommonDDL/RegionalOfficeNameDDL";
import { FieldStationOfficerDDL } from "../../../../Components/CommonDDL/FieldStationOfficerDDL";
import { ProjectWiseSurveyorDistrictPopUpTableDataAPI, ProjectWiseSurveyorPostAPI } from "../../../../Helper/Redux/MasterSlice/ProjectWiseSurveyorSlice";
import { SurveyorNameDDL } from "../../../../Components/CommonDDL/SurveyorNameDDL";
import { Loading } from "../../../../Helper/LogoLoader/LogoLoader";

export default function DistrictViewPopUp(props) {

    const { handleShowViewModal, handleIsPost, ShowViewModal, IsSearch, IsClear, IsPost, setIsClear } = props
    const { flag, data } = ShowViewModal

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    // console.log(flag)

    useEffect(() => {
        const Data = {
            M_StateID: data?.m_StateNameID,
            M_TableUserMasterID: UserID,
            M_ProjectID: data?.m_ProjectID,
            M_Surveyor_TableUserID: data?.m_Surveyor_TableUserID,
            M_FieldStationOfficerID: 0,
            Flag: flag,
            Top: '99999',
            token: token,
        }

        dispatch(ProjectWiseSurveyorDistrictPopUpTableDataAPI({ Data }))
    }, [])

    const { isLoading, tableData } = useSelector(state => state.ProjectWiseSurveyorDistrictPopUpTableData)

    return (
        <>
            {isLoading && <Loading />}
            <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "#00000055" }}
            >
                <div className="modal-dialog modal-dialog-centered" role="document" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title ml-4" id="exampleModalLongTitle">
                                {flag} View PopUp
                            </h5>
                            <button
                                onClick={() => handleShowViewModal(false, '')}
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mx-4">
                            <div className="row">
                                <div className="table-responsive p-0 pt-3 pt-lg-0 tableFixHeader" >
                                    <table className="table table-bordered ">
                                        <thead>
                                            <tr className="bg-gradient-dark text-white">
                                                <th className=" w-6 v_sr_width">
                                                    Sr.No
                                                </th>
                                                {
                                                    flag == "PopUp" || flag == "FO" ?
                                                        <>
                                                            <th className=" ps-2"> RO </th>
                                                            <th className=" ps-2"> Field Station </th>
                                                        </>
                                                        :
                                                        ''

                                                }
                                                {
                                                     flag == 'RO' ?
                                                    <th className=" ps-2"> {flag} Name </th>
                                                        :
                                                        flag == 'PopUp' ?
                                                        <th className=" ps-2"> District Name </th>
                                                            :
                                                            ''
                                                }
                                                
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((i, j) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td align="center">
                                                                    {j + 1}
                                                                </td>
                                                                {
                                                                    flag == "PopUp" || flag == "FO" ?
                                                                        <>
                                                                            <td>{i.m_RegionalOffice ? i.m_RegionalOffice : '-'}</td>
                                                                            <td>{i.m_FieldStationOfficer ? i.m_FieldStationOfficer : '-'}</td>
                                                                        </>
                                                                        :
                                                                        ''

                                                                }
                                                                {
                                                                   flag == 'RO' ?
                                                                        <td>{i.m_RegionalOffice ? i.m_RegionalOffice : '-'}</td>
                                                                        :
                                                                        flag == 'PopUp' ?
                                                                            <td>{i.districtName ? i.districtName : '-'}</td>
                                                                            :
                                                                            ''
                                                                }

                                                            </tr>
                                                        </>
                                                    )
                                                })
                                                    :
                                                    <tr>No data found</tr>
                                            }
                                        </tbody>
                                    </table>

                                </div>

                                {/* <div className="col-12">
                                    <div className="form-group float-end mt-lg-3">

                                        <button type="button" className="btn btn-outline-dark border-2 mx-2"
                                           
                                            onClick={handelAssignClicked}> {flag == 'Update' ? "Update" : "Add"}</button>

                                        <button type="button" className="btn btn-danger border-2"
                                            onClick={handleClearCancel}>
                                            {flag == 'Update' ? "Cancel" : "Clear"}
                                        </button>



                                    </div>
                                </div> */}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
